

/*************************************************************************************
 * 
 *                              流相关常量
 * 
 * ***********************************************************************************/


// 流命名空间名
const STREAM_NAMESPACE_NAME = "STREAM_MIDDLEWAYE_NAMESPACE";

// 流服务库名称
const STREAM_SERVER_DATABASE_NAME = "STREAM_MIDDLEWAYE_DATABASE";

// 流服务表名称
const STREAM_SERVER_TABLE_NAME = "STREAM_MIDDLEWAYE_SERVER_TABLE";


// 完整的资源路径
const STREAM_COMPLETE_PATH = `${STREAM_NAMESPACE_NAME}.${STREAM_SERVER_DATABASE_NAME}.${STREAM_SERVER_TABLE_NAME}`;

/**
 * 命名空间的默认数据
 */
 const DEDAULT_STREAM_NAMESPACE_DATA = {
    "id": STREAM_NAMESPACE_NAME,
    "name": STREAM_NAMESPACE_NAME,
    "displayName": "流文件服务空间",
    "path": "./databases/databaseStream",
    "isSystem": false,
    "isTimingDisk": true,
    "isEnable": true,
    "isRelativePath": false,
    "description": "所有的流文件操作"
};



      


module.exports = {
    STREAM_NAMESPACE_NAME,
    STREAM_SERVER_DATABASE_NAME,
    STREAM_SERVER_TABLE_NAME,
    STREAM_COMPLETE_PATH,
    DEDAULT_STREAM_NAMESPACE_DATA
}







